<div class="user-management-block">
    <div class="uitk-l-grid__row">
        <div class="uitk-l-grid__col--12 ps-0 pe-0">
            <div class="user-management-action-block">
                <div class="row select-section">
                    <div class=" col-md-7 col-sm-7 col-lg-7 col-xl-7 col-xs-7">
                        <div class="add-section">
                            <div class="form-group w-40">

                                <mat-form-field [disableRipple]="true"  appearance="outline" class="inline-form-edit chip-select-stakeholder select-user-dropdown" floatLabel="never">
                                    <mat-chip-grid #chipList>
                                        <ng-container *ngIf="selectedAddUserslist && selectedAddUserslist?.length > 0">
                                            <mat-chip-row class="stk-mat-chip" *ngFor="let selectedUsers of selectedAddUserslist" (removed)="removeSelectedUser(selectedUsers)">
                                                {{selectedUsers.givenName}} {{selectedUsers.sn}}
                                                <mat-icon matChipRemove>cancel</mat-icon>
                                            </mat-chip-row>
                                        </ng-container>
                                    </mat-chip-grid>
                                    <input placeholder="Search by Name/Mail (min 4 chars)" [ngClass]="{'no-input-field' : selectedAddUserslist?.length > 0}" matInput  [matAutocomplete]="auto" (keyup)="onSearchUser($event)"
                                        [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes">
                                    <mat-autocomplete showPanel=true class="lob-options-list" #auto="matAutocomplete"
                                        (optionSelected)="getSelectedUsers($event)">
                                    
                                        <mat-option [disabled]="user?.disable" *ngFor="let user of searchUserList"
                                            title="{{ user.MSId }}<{{ user.displayName }}>({{ user.mail }})" [value]="user">
                                            {{ user.MSId||user.msid }}<{{ user.displayName }}>({{ user.mail }})
                                        </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                    <div class=" col-md-5 col-sm-5 col-lg-5 col-xl-5 col-xs-5">
                        <div class="action-button-section">
                            <button
                                class="btn stk-action-add  uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button"
                                mat-mdc-raised-button [disabled]="selectedAddUserslist?.length == 0"
                                (click)="onAddUser()">Add {{role}}</button>
                            <button
                                class="btn stk-action-add ms-3 ml-3 remove-btn uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button"
                                mat-mdc-raised-button (click)="onRemoveUser()"
                                [disabled]="selectedRemoveUserlist?.length == 0">Remove {{role}}</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="table-block"
                *ngIf="actionType == 'Edit' || (actionType == 'Add' && dataSourceDetails && dataSourceDetails?.data?.length > 0)">
                <ng-container>
                    <app-maintenance-table-v4 [TABLE_CONFIG]="TABLE_CONFIG" [COLUMNS]="TABLE_COLUMNS"
                        [SORT_CONFIG]="sortConfig" [dataSource]="dataSourceDetails" [SCHEMA]="DATA_SCHEMA"
                        [pageSize]="TABLE_CONFIG.pageSize" [isTableRefreshed]="isTableRefreshed"
                        [pageIndex]="TABLE_CONFIG.pageIndex"  (checkBoxEvent)="checkboxClick($event)"
                        (updateStatusEvent)="updateLeadStatus($event)" [pageSizeOptions]="[5,10,15]" [noRowHeight]="true">
                    </app-maintenance-table-v4>
                </ng-container>
            </div>
        </div>
    </div>
</div>
